export function urlHasBevParam(): boolean {
  return new URLSearchParams(window.location.search).has('bev')
}
